import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import UserRegister from '../components/Pages/UserRegister.vue';
import UserConfirm from '../components/Pages/UserConfirm.vue';
import ProductView from '../components/Pages/ProductView.vue';
import ArticleView from '../components/Pages/ArticleView.vue';
import TransactionBackSite from '../components/Pages/TransactionBackSite.vue';
import CategoryView from '../components/Pages/CategoryView.vue';
import UserView from '../components/Pages/UserView.vue';
import UserLoginView from '../components/Pages/UserLoginView.vue';
import SearchView from '../components/Pages/SearchView.vue';
import UserHistoryView from '../components/Pages/UserHistoryView.vue';
import CartView from '../components/Pages/CartView.vue';
import MainPage from '../components/Pages/MainPage.vue';
import ShopBody from '../components/Partials/ShopBody/ShopBody.vue';

Vue.use(VueRouter);

const routes: Array<any> = [
  {
    path: '/',
    name: 'Home',
    component: MainPage,
    children: [
      {
        path: '',
        component: ShopBody,
      },
      {
        path: '/register',
        component: UserRegister,
      },
      {
        path: '/cart',
        component: CartView,
      },
      {
        path: '/register/confirm/:uid',
        component: UserConfirm,
      },
      {
        path: '/product/:slug',
        component: ProductView,
      },
      {
        path: '/article/:slugged',
        component: ArticleView,
      },
      {
        path: '/user/history',
        component: UserHistoryView,
      },
      {
        path: '/search',
        component: SearchView,
      },
      {
        path: '/user/login',
        component: UserLoginView,
      },
      {
        path: '/category/:slug',
        component: CategoryView,
        meta: { link: 'getbycategory' },
      },
      {
        path: '/platform/:slug',
        component: CategoryView,
        meta: { link: 'getbyplatform' },
      },
      {
        path: '/attribute/:slug',
        component: CategoryView,
        meta: { link: 'getbyattribute' },
      },
      {
        path: '/product/show/preorders',
        component: CategoryView,
        meta: { link: 'preorders' },
      },
      {
        path: '/user/profile',
        component: UserView,
      },
      {
        path: '/transaction',
        component: TransactionBackSite,
      },
    ],
  },
  // {
  // path: '/',
  // name: 'About',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  // },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
